import { create } from "zustand";
import api from "../api/axios";

const useLeaveStore = create((set) => ({
  leaveData: [],
  loading: false,

  fetchLeaveData: async ({
    selectedCompany,
    permissions,
  }) => {
    try {
      set({ loading: true });

      const currentDate = new Date();

      const toDate = currentDate
        .toISOString()
        .substr(0, 10);

      currentDate.setDate(
        currentDate.getDate() - 30
      );

      const fromDate = currentDate
        .toISOString()
        .substr(0, 10);

      let apiUrl = "";

      const hasViewAllManagedLeaveHistory =
        permissions.some(
          (permission) =>
            permission.name ===
            "view_managed_leave_history"
        );

      const hasViewAllLeaveHistory =
        permissions.some(
          (permission) =>
            permission.name ===
            "view_all_leave_history"
        );

      if (
        hasViewAllManagedLeaveHistory
      ) {
        apiUrl =
          `/employees/leaveHistoryForManagers?from=${fromDate}&to=${toDate}`;
      } else if (
        hasViewAllLeaveHistory
      ) {
        apiUrl =
          `/employees/companyWiseLeaveHistory?from=${fromDate}&to=${toDate}&company=${selectedCompany}`;
      } else {
        console.log(
          // "User does not have required permissions."
        );

        set({ loading: false });
        return [];
      }

      const response =
        await api.get(apiUrl);

      const dataObject =
        response.data?.data || {};

      const leaveData = Object.keys(
        dataObject
      ).map(
        (key) => dataObject[key]
      );

      set({
        leaveData,
        loading: false,
      });

      return leaveData;
    } catch (error) {
      console.log(error);

      set({
        loading: false,
      });

      return [];
    }
  },
}));

export default useLeaveStore;